export const RaceCard = ({ title, content }) => (
  <div className="bg-white rounded-xl shadow-sm border p-6">
    <h3 className="text-xl font-bold mb-3">{title}</h3>
    <ul className="list-disc list-inside space-y-1 text-gray-700">
      {content.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);